const data = {
    updateTeamName: {
        '-1': 'DB_ERROR',
        '1': 'TEAM_NAME_SAVED',
        '2': 'TEAM_NAME_ALREADY_EXISTS',
        '3': 'ROUND_IS_LOCKED',
        '-555': "EXP_TEAM_NAME_NULL",
    },
    deleteFantasyTeam: {
        '-1': 'DB_ERROR',
        '1': 'TEAM_SAVED',
        '2': 'TEAM_NAME_ALREADY_EXISTS',
        '3': 'ROUND_IS_LOCKED',
    },
    transfers: {
        '-9999': 'EXP_INVALID_TEAM_CF',
        '-999': 'EXP_INVALID_TRANSFER_DML',
        '-1': 'OTHER_EXCEPTION',
        '0': 'EXP_SOME_ERROR_OCCURED',
        '1': 'TEAM_SAVED',
        '2': 'EXP_INVALID_SUBSTITUTION',
        '5': 'EXP_GAMEDAY_NOT_CURRENT',
        '7': 'EXP_INVALID_GAMEDAY_PLAYER_COUNT',
        '8': 'EXP_INVALID_MATCHDAY_PLAYER_COUNT',
        '9': 'EXP_DUPLICATE_PLAYERID_FOUND',
        '12': 'EXP_TEAM_VALUE_EXCEDED',
        '13': 'EXP_GAMEDAY_COMPOSITION_NOT_MATCH',
        '15': 'EXP_CAPTAIN_NOT_EXISTS',
        '16': 'EXP_EXCEEDED_LIMIT_PLAYERS_PER_TEAM',
        '17': 'EXP_INVALID_SKILL',
        '22': 'EXP_PLAYER_INSERTED_DELETED_NOT_MATCH',
        '23': 'EXP_TEAM_BALANCE_NEGATIVE',
        '24': 'EXP_MATCHDAY_COMPOSITION_NOT_MATCH',
        '26': 'EXP_INVALID_BENCHPLAYER_COUNT',
        '27': 'EXP_FAIL_TO_CHECK_TEAM_EXISTS',
        '28': 'EXP_TEAM_NOT_EXISTS',
        '29': 'EXP_PLAYER_IN_POSITION_ZERO',
        '30': 'EXP_PLAYER_IN_COUNT_NOT_MATCH',
        '31': 'EXP_PLAYER_OUT_COUNT_NOT_MATCH',
        '32': 'EXP_PLAYER_OUT_POSITION_ZERO',
        '33': 'EXP_PLAYER_IN_OUT_NOT_MATCHED',
        '1001': 'EXP_GAMEDY_LOCKED',
    },
    saveCaptain: {
        '-9999': 'EXP_INVALID_TEAM_CF',
        '-1': 'OTHER_EXCEPTION',
        '0': 'EXP_SOME_ERROR_OCCURED',
        '1': 'CAPTAIN_SAVED',
        '7': 'EXP_INVALID_GAMEDAY_PLAYER_COUNT',
        '8': 'EXP_INVALID_MATCHDAY_PLAYER_COUNT',
        '9': 'EXP_DUPLICATE_PLAYERID_FOUND',
        '12': 'EXP_TEAM_VALUE_EXCEDED',
        '13': 'EXP_GAMEDAY_COMPOSITION_NOT_MATCH',
        '15': 'EXP_CAPTAIN_NOT_EXISTS',
        '16': 'EXP_EXCEEDED_LIMIT_PLAYERS_PER_TEAM',
        '17': 'EXP_INVALID_SKILL',
        '23': 'EXP_TEAM_BALANCE_NEGATIVE',
        '24': 'EXP_MATCHDAY_COMPOSITION_NOT_MATCH',
        '26': 'EXP_INVALID_BENCHPLAYER_COUNT',
        '1001': 'EXP_GAMEDY_LOCKED',
    },
    createLeague: {
        '1': 'LEAGUE_SUCCESS',
        '3': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '4': 'EXP_LEAGUE_NAME_NULL',
        '99': 'EXP_LEAGUE_JOIN_EXCEEDED',
        '0': 'DB_ERROR',
        '-1': 'DB_ERROR',
        '-555': "EXP_LEAGUE_NAME_NULL",
    },
    joinLeague: {
        '1': 'LEAGUE_JOIN_SUCCESS',
        '6': 'EXP_LEAGUE_DELETED',
        '7': 'EXP_INVALID_LEAGUE_CODE',
        '9': 'EXP_USER_ALREADY_MEMBER',
        '10': 'EXP_USER_ADMIN_LOCKED',
        '8': 'EXP_LEAGUE_MEMBER_EXCEEDED',
        '99': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '0': 'DB_ERROR',
        '-1': 'DB_ERROR'
    },
    reActivate: {
        '1': 'LEAGUE_REACTIVATE_SUCCESS',
        '5': 'EXP_LEAGUE_ALREADY_RELAUNCH',
        '3': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '4': 'EXP_LEAGUE_NAME_NULL',
        '99': 'EXP_LEAGUE_JOIN_EXCEEDED',
        '-1': 'DB_ERROR',
    },
    reJoin: {
        '1': 'reJoinInfo',
        '2': 'REJOIN_REQUEST_SEND_TO_ADMIN_OWNER',
        '3': 'EXP_LEAGUE_DELETED',//'EXP_LEAGUE_JOIN_EXCEEDED',
        '99': 'EXP_LEAGUE_JOIN_EXCEEDED',//'DB_ERROR',
        '-1': 'DB_ERROR',//'REJOIN_REQUEST_SEND_TO_ADMIN_OWNER',
        //'2' : 'MEMBER_DIRECTLY_PART_OF_THE_LEAGUE',
    },
    deletePreviousLeague: {
        '1': 'deletePreviousLeague_SUCCESS',
        '5': 'EXP_LEAGUE_ALREADY_DELETED',
        '-1': 'DB_ERROR',
    },
    deletePreviousMembersLeague: {
        '1': 'deletePreviousMembersLeague_SUCCESS',
        '5': 'EXP_MEMBER_ALREADY_DELETED_LEAGUE',
        '-1': 'DB_ERROR',
    },
    leaveLeague: {
        '1': "SUCCESS_LEAVE_LEAGUE",
        '-1': "FAILED_LEAVE_LEAGUE",
    },
    suspension: {
        '1': "SUCCESS_SUSPENSION",
        '11': "EXP_INVALID_LEAGUE_OWNER",
        '-1': 'DB_ERROR',
    },
    deleteLeague: {
        '1': "SUCCESS_DELETE_LEAGUE",
        '2': "FAILED_DELETE_LEAGUE",
        '-1': 'DB_ERROR'
    },
    updateLeagueName: {
        '1': "SUCCESS_UPDATE_LEAGUE_NAME",
        '2': "FAILED_UPDATE_LEAGUE_NAME",
        '4': "EXP_LEAGUE_NAME_NULL",
        '11': 'FAILED_UPDATE_LEAGUE_NAME',
        '-1': 'DB_ERROR',
        '-555': "EXP_LEAGUE_NAME_NULL",
    },
    createTeam: {
        '1': "TEAM_CREATED_SUCCESSFULLY",
        '1001': "EXP_GAMEDY_LOCKED",
        '101': "EXP_INVALID_PLAYER_COUNT",
        '1002': "EXP_TEAM_NAME_NULL",
        '1003': "EXP_TEAM_NAME_EXISTS",
        '102': "EXP_TEAM_ALREADY_CREATED",
        '103': "EXP_INVALID_OPT_TYPE",
        '10': "EXP_TEAM_NOT_CREATED",
        '0': "EXP_SOME_ERROR_OCCURED",
        '6': "EXP_TEAM_ALREADY_CREATED_FOR_TOUR_WEEK",
        '7': "EXP_IVALID_GAMEDAY_PLAYER_COUNT",
        '8': "EXP_IVALID_MATCHDAY_PLAYER_COUNT",
        '9': "EXP_DUPLICATE_PLAYERID_FOUND",
        '11': "EXP_PLAYER_DOES_NOT_EXISTS",
        '12': "EXP_TEAM_VALUE_EXCEEDED",
        '13': "EXP_INVALID_GAMEDAY_COMPOSITION",
        '24': "EXP_INVALID_MATCHDAY_COMPOSITION",
        '14': "EXP_INVALID_BENCH_PLAYER_COUNT",
        '15': "EXP_CAPTAIN_DOES_NOT_EXISTS",
        '16': "EXP_EXCEEDED_LIMT_PLAYERS_PER_TEAM",
        '17': "EXP_INVALID_SKILL_CN",
        '18': "EXP_USER_DOES_NOT_EXISTS",
        '5': "EXP_GAMEDAY_IS_NOT_CURRENT",
    },
    getRules: {}
};
const defaultError = 'api_error';
const validator = {
    get(object, property) {
        if (typeof object[property] === 'object' && object[property] !== null) {
            return new Proxy(object[property], validator)
        } else {
            return object.hasOwnProperty(property) ? object[property] : defaultError;
        }
    }
};
const apiError = new Proxy(data, validator);
export default apiError;


// WEBPACK FOOTER //
// ./src/constants/api-error.js